export default __webpack_public_path__ + "static/media/thumb-Marine-Receiver-3.b8b5f4de.png";